import { TableFilter, TFilterValues } from '@components/table/types';
import { getUndefinedIfEmpty } from '@utils/getUndefinedIfEmpty';

export type FilterQueryParam = Record<
  string,
  string | ((value: string) => { key: string; value: string | string[] }[] | null)
> | null;

export const handleTableFilterQueryParams = ({
  onSetQueryParams,
  filterValues,
  filterQueryParam,
  ignoreQueryParams = [],
}: {
  filterQueryParam?: Record<
    string,
    string | ((value: string | any) => { key: string; value: string | string[] }[] | null)
  > | null;
  filterValues: TFilterValues;
  ignoreQueryParams?: string[];
  onSetQueryParams: (callback: (prev: any) => any) => void;
}) => {
  const queryFilters: any = {};

  Object.entries(filterValues).forEach(([key, value]) => {
    if (getUndefinedIfEmpty(value) === undefined) {
      return;
    }

    if (filterQueryParam) {
      const queryKey = filterQueryParam[key];

      if (!queryKey) {
        if (ignoreQueryParams.includes(key) || ['sort', 'debugMode', 'quickFilter'].includes(key)) {
          return;
        }
        console.warn('filterQueryParam not defined for key: ', key);
        return;
      }

      if (typeof queryKey === 'function') {
        const filtersToAdd = queryKey(value);
        if (!filtersToAdd || filtersToAdd.length === 0) {
          return;
        }

        filtersToAdd.forEach((filterToAdd) => {
          queryFilters[filterToAdd.key] = filterToAdd.value;
        });
      } else {
        if (typeof value === 'object') {
          switch (value.type) {
            case TableFilter.DATE_RANGE: {
              if (value.min) {
                // FUTURE: may need to allow a way to override Min/Max, but this is common in our apis
                queryFilters[`${queryKey}Min`] = value?.min;
              }
              if (value?.max) {
                queryFilters[`${queryKey}Max`] = value?.max;
              }

              break;
            }
            case TableFilter.NUMBER_RANGE: {
              if (value.min) {
                queryFilters[`${queryKey}Min`] = value?.min;
              }
              if (value?.max) {
                queryFilters[`${queryKey}Max`] = value?.max;
              }

              break;
            }
            default:
              if (value?.value) {
                queryFilters[queryKey] = value?.value;
              } else if (Array.isArray(value)) {
                // desired outcome is firstItem.value&queryKey=secondItem.value&queryKey=thirdItem.value
                const ids = value?.map((v: string | { value: string }) => (typeof v === 'string' ? v : v.value));
                queryFilters[queryKey] = ids;
              } else if (value) {
                queryFilters[queryKey] = value;
              } else {
                console.warn('handler not defined for key: ', key);
              }
              break;
          }
        } else {
          queryFilters[queryKey] = value instanceof Date ? value.toJSON() : value;
        }
      }
    }
  });

  onSetQueryParams((prev: any) => ({
    ...prev,
    filters: queryFilters,
  }));
};
